export class AgentProduct {
}
export class AgentProductRights {
}
export class AgentProductPermissions {
}
//# sourceMappingURL=agent-product.js.map